<template>
    <div class="modal-panel">
        <div class="overlay" @click="close"></div>

        <div class="menu">
            <div class="position-relative">
                <div class="d-flex login-panel">
                    <div class="d-flex login-header">
                        <div class="login-header-title">
                            Contributor Log-In
                        </div>
                        <span class="d-flex login-header-button pointer" @click="close">
                            <span class="material-symbols-outlined material-symbols-outlined-400 close-icon">
                                close
                            </span>
                            Close
                        </span>
                    </div>
                    <form v-if="!state.recoverMode" @submit.prevent="loginHandler">
                        <div class="d-flex flex-column login-content">
                            <div class="d-flex flex-column login-form">
                                <div class="d-flex flex-column form-item-panel">
                                    <label class="login-form-label">Username</label>
                                    <div class="d-flex flex-column">
                                        <input type="text"
                                               v-model="data.username"
                                               :class="{'is-invalid': v$.data.username.$error}"
                                               class="form-control form-control-sm"
                                               placeholder="Username"
                                               @keyup.enter="loginHandler"
                                               name="username">
                                        <span class="invalid-feedback">
                                            Required field!
                                        </span>
                                    </div>
                                </div>
                                <div class="d-flex flex-column form-item-panel">
                                    <label class="login-form-label">Password</label>
                                    <div class="d-flex flex-column">
                                        <input
                                            v-model="data.password"
                                            type="password"
                                            @keyup.enter="loginHandler"
                                            :class="{'is-invalid': v$.data.password.$error}"
                                            class="form-control form-control-sm"
                                            placeholder="Password"
                                            name="password">
                                        <span class="invalid-feedback">
                                            Required field!
                                        </span>
                                    </div>
                                </div>
                                <div class="form-check">
                                    <div class="remember-form-check-input-outer"
                                         :class="data.remember ? 'remember-guide-checkbox-selected' : ''">
                                        <input class="remember-form-check-input" type="checkbox"
                                               v-model="data.remember"
                                               id="remember">
                                    </div>
                                    <label class="form-check-label" for="remember">
                                        Remember me
                                    </label>
                                </div>
                            </div>

                            <div class="w-100 buttons">
                                <button type="button" class="btnstyle w-100 login-button" @click="loginHandler">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="button-text">Login</div>

                                        <span class="material-symbols-outlined material-symbols-outlined-400 arrow-icon"
                                        >arrow_forward</span>
                                    </div>
                                </button>
                                <div class="d-flex w-100 justify-content-center">
                                    <button @click="state.recoverMode = true"
                                            class="btn btn-link px-0" type="button">Forgot password?
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <form v-else-if="state.recoverMode && !state.recoverCodeMode && !state.changePasswordMode"
                          @submit.prevent="sendRecoverHandler">
                        <div class="d-flex flex-column login-content">
                            <div class="d-flex flex-column login-form">
                                <div class="d-flex flex-column form-item-panel">
                                    <label class="login-form-label">Please provide an email for password
                                        recovery</label>
                                    <div class="d-flex flex-column">
                                        <input type="text"
                                               v-model="recoverData.email"
                                               placeholder="Email"
                                               :class="{'is-invalid': vRecover$.recoverData.email.$error}"
                                               class="form-control form-control-sm"
                                               name="email">
                                        <span class="invalid-feedback"
                                              v-show="vRecover$.recoverData.email.required.$invalid">
                                                Required!
                                            </span>
                                        <span class="invalid-feedback"
                                              v-show="vRecover$.recoverData.email.email.$invalid">
                                                Invalid email format!
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="w-100 buttons">
                                <button type="button" class="btnstyle w-100 login-button" @click="sendRecoverHandler">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="button-text">Send</div>

                                        <span class="material-symbols-outlined material-symbols-outlined-400 arrow-icon"
                                        >arrow_forward</span>
                                    </div>
                                </button>
                                <div class="d-flex w-100 justify-content-center">
                                    <button class="btn btn-link px-0"
                                            @click="state.recoverCodeMode = true"
                                            type="button">I have a code
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <!-- RECOVER - CODE -->
                    <form v-else-if="state.changePasswordMode && state.recoverMode && state.recoverCodeMode"
                          @submit.prevent="submitPasswordUpdateHandler">
                        <div class="d-flex flex-column login-content">
                            <div class="d-flex flex-column login-form">
                                <div class="d-flex flex-column form-item-panel">
                                    <label class="login-form-label">New Password</label>
                                    <div class="d-flex flex-column">
                                        <input v-model="passwordData.password"
                                               :class="{'is-invalid': vPassword$.passwordData.password.$error}"
                                               class="form-control form-control-sm"
                                               type="password"
                                               name="new-password">
                                        <span class="invalid-feedback"
                                              v-show="vPassword$.passwordData.password.$invalid">
                                                    Required!
                                            </span>
                                        <span class="invalid-feedback"
                                              v-show="vPassword$.passwordData.password.minLength.$invalid">
                                                    The password should have at least {{
                                                vPassword$.passwordData.password.minLength.$params.min
                                            }} chars
                                            </span>
                                        <span class="invalid-feedback"
                                              v-show="vPassword$.passwordData.password.required.$invalid">
                                                Required!
                                        </span>
                                    </div>
                                </div>
                                <div class="d-flex flex-column form-item-panel">
                                    <label class="login-form-label">Confirm Password</label>
                                    <div class="d-flex flex-column">
                                        <input v-model="passwordData.confirmPassword"
                                               :class="{'is-invalid': vPassword$.passwordData.confirmPassword.$error}"
                                               class="form-control form-control-sm"
                                               type="password"
                                               name="confirm-password">
                                        <span class="invalid-feedback">
                                                Both values must be equal!
                                            </span>
                                    </div>
                                </div>
                            </div>

                            <div class="w-100 buttons">
                                <button type="button" class="btnstyle w-100 login-button"
                                        @click="submitPasswordUpdateHandler">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="button-text">Update</div>

                                        <span class="material-symbols-outlined material-symbols-outlined-400 arrow-icon"
                                        >arrow_forward</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </form>

                    <form v-else @submit.prevent="sendRecoverCodeHandler">
                        <div class="d-flex flex-column login-content">
                            <div class="d-flex flex-column login-form">
                                <div class="d-flex flex-column form-item-panel">
                                    <label class="login-form-label">Please provide the code received by email</label>
                                    <div class="d-flex flex-column">
                                        <input type="text"
                                               v-model="recoverCodeData.code"
                                               :class="{'is-invalid': vCode$.recoverCodeData.code.$error}"
                                               class="form-control form-control-sm"
                                               placeholder="Code"
                                               name="code">
                                        <span class="invalid-feedback"
                                              v-show="vRecover$.recoverData.email.required.$invalid">
                                                Required!
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="w-100 buttons">
                                <button type="button" class="btnstyle w-100 login-button"
                                        @click="sendRecoverCodeHandler">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="button-text">Send</div>

                                        <span class="material-symbols-outlined material-symbols-outlined-400 arrow-icon"
                                        >arrow_forward</span>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {computed, reactive, ref} from 'vue'

import {useMainStore} from "@/stores/mainStore";
import useVuelidate from '@vuelidate/core';
import {email, minLength, required, sameAs} from '@vuelidate/validators';
import api from '@/http/api';

const data = ref<any>({username: '', password: '', remember: false})
const passwordData = ref<any>({password: '', confirmPassword: '', code: ''})
const recoverData = ref<any>({email: ''})
const recoverCodeData = ref<any>({code: ''})

const state = reactive({
    recoverMode: false,
    recoverCodeMode: false,
    changePasswordMode: false
})

const mainStore = useMainStore();

function close() {
    // console.log('calling close')
    mainStore.showLogin(false)
}

function loginHandler() {
    v$.value.$touch();
    if (v$.value.$invalid) {
        mainStore.showAlert({
            title: 'Error!',
            type: 'error',
            message: 'Form data error!',
        })
        return
    }

    mainStore.showMask(true);
    const formData = new FormData();
    formData.append('username', data.value.username);
    formData.append('password', data.value.password);
    if (data.value.remember) {
        formData.append('remember-me', 'true');
    }
    /*const tokenElement = document.getElementById('token_element');
    if(tokenElement) {
        formData.append(tokenElement.name, tokenElement.value);
    }*/

    api.post('/login', formData)
        .then((/*response*/) => {
            // console.debug('login response: %o', response)
            mainStore.loadWhoAmI();
            mainStore.showLogin(false)
        })
        .catch(error => {
            // console.error('login error: %o', error)
            const message = error.response?.data?.exception ?? undefined;
            mainStore.showAlert({
                type: 'error',
                message: 'Login error!',
                helpText: message
            })
        })
        .finally(() => {
            mainStore.showMask(false);
        })
}

function sendRecoverHandler() {
    vRecover$.value.$touch();

    if (vRecover$.value.$invalid) {
        mainStore.showAlert({
            title: 'Error!',
            type: 'error',
            message: 'Form data error!',
        })
        return
    }
    mainStore.showMask(true);

    api.post('/recover-password', {...recoverData.value})
        .then((/*response*/) => {
            // console.debug('recover response: ', response)
            mainStore.showAlert({
                type: 'success',
                message: 'Password recovery email sent!',
            });
            cleanFormHandler();
            state.recoverCodeMode = true;
        })
        .catch((error) => {
            if (error.status === 500) {
                mainStore.showAlert({
                    type: 'error',
                    message: 'User not found in the system!',
                });
            } else {
                mainStore.showAlert({
                    type: 'error',
                    message: 'Password recovery error!',
                });
            }
        })
        .finally(() => {
            mainStore.showMask(false);
        })

}

function sendRecoverCodeHandler() {
    // console.debug('sendRecoverCodeHandler')
    vCode$.value.$touch();
    if (vCode$.value.$invalid) {
        mainStore.showAlert({
            title: 'Error!',
            type: 'error',
            message: 'Form data error!',
        })
        return
    }

    mainStore.showMask(true);
    api.post('/recover-password/code', {...recoverCodeData.value})
        .then(() => {
            // console.debug('sendRecoverCodeHandler response: ', response);
            passwordData.value.code = recoverCodeData.value.code;
            state.changePasswordMode = true
        })

        .catch((error) => {
            // console.error('sendRecoverCodeHandler error: ', error);
            if (error.status === 500) {
                mainStore.showAlert({
                    type: 'error',
                    message: 'Code not found in the system!',
                });
            } else {
                mainStore.showAlert({
                    type: 'error',
                    message: 'Error sending recover code!',
                })
            }
        })
        .finally(() => {
            mainStore.showMask(false);
        })
}

const submitPasswordUpdateHandler = () => {
    // console.debug('submitPasswordUpdateHandler')
    vPassword$.value.$touch();

    if (vPassword$.value.$invalid) {
        mainStore.showAlert({
            title: 'Error!',
            type: 'error',
            message: 'Form data error!',
        })
        return
    }

    mainStore.showMask(true);
    api.post('/update-recover-password', {password: passwordData.value.password, code: passwordData.value.code})
        .then((/*response*/) => {
            // console.debug('submitPasswordUpdateHandler response: ', response);
            mainStore.showAlert({
                type: 'success',
                message: 'Password updated!',
            })
            mainStore.loadWhoAmI();
            //window.location.reload()
            mainStore.showLogin(false)
            cleanFormHandler()
        })
        .catch((/*error*/) => {
            // console.error('submitPasswordUpdateHandler error: ', error)
            mainStore.showAlert({
                type: 'error',
                message: 'Error updating password!',
            })
        })
        .finally(() => {
            mainStore.showMask(false);
        })

}

function cleanFormHandler() {
    data.value.username = '';
    data.value.password = '';
    recoverData.value.email = '';
    recoverCodeData.value.code = '';
    passwordData.value.password = '';
    passwordData.value.confirmPassword = '';
    vRecover$.value.$reset();
}

const rules = computed(() => ({
        data: {
            username: {
                required
            },
            password: {
                required
            },
        }
    })
)
const v$ = useVuelidate(rules, {data}, {$lazy: true})

const recoverRules = computed(() => ({
        recoverData: {
            email: {
                required,
                email,
            },
        }
    })
)
const vRecover$ = useVuelidate(recoverRules, {recoverData}, {$lazy: true})

const codeRules = computed(() => ({
        recoverCodeData: {
            code: {
                required,
            },
        }
    })
)
const vCode$ = useVuelidate(codeRules, {recoverCodeData}, {$lazy: true})


const passwordRules = computed(() => ({
    passwordData: {
        password: {
            required,
            minLength: minLength(8)
        },
        confirmPassword: {
            same: sameAs(passwordData.value.password)
        }
    }
}))

const vPassword$ = useVuelidate(passwordRules, {passwordData}, {$lazy: true})


</script>

<style scoped lang="scss">
.modal-panel {
    position: absolute;
    top: 0;
}

.login-panel {
    width: 577px;
    flex-direction: column;
    background: rgba(244, 247, 255, 1);
    border-radius: 12px;
    padding-bottom: 36px;
    gap: 36px;
    @media (min-width: $max-xl-screen) {
        padding-bottom: 48px;
        gap: 48px;
        border-radius: 16px;
        width: 761.64px;
    }
    @media (max-width: $max-md-screen) {
        padding-bottom: 32px;
        gap: 32px;
        border-radius: 8px;
        width: 85vw;
    }
    @media (max-width: $max-sm-screen) {
        padding-bottom: 16px;
        gap: 16px;
        border-radius: 4px;
        width: 85vw;
    }
}

.login-header {
    width: 100%;
    height: 83px;
    justify-content: space-between;
    padding: 24px 36px;;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    background: linear-gradient(254.56deg, #3E69A6 0.74%, #233F68 99.26%);
    box-shadow: 0 4px 4px 0 rgba(0, 6, 122, 0.25);
    @media (min-width: $max-xl-screen) {
        height: 105.36px;
        padding: 31.68px 47.52px;
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
        box-shadow: 0px 5.28px 5.28px 0px rgba(0, 6, 122, 0.25);
    }
    @media (max-width: $max-md-screen) {
        height: 86px;
        padding: 24px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        box-shadow: 0px 2.19px 2.19px 0px rgba(0, 6, 122, 0.25);
    }
    @media (max-width: $max-sm-screen) {
        height: 43px;
        padding: 12px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        box-shadow: 0px 1.1px 1.1px 0px rgba(0, 6, 122, 0.25);
    }
}

.login-header-title {
    font-family: Raleway;
    font-weight: 600;
    font-size: 30px;
    line-height: 100%;
    letter-spacing: 0;
    color: rgba(235, 243, 255, 1);
    @media (min-width: $max-xl-screen) {
        font-size: 36px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 32px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 16px;
    }
}

.login-header-button {
    gap: 5px;
    align-items: center;

    font-family: Raleway;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
    color: rgba(235, 243, 255, 1);
    @media (min-width: $max-xl-screen) {
        gap: 6.6px;
        font-size: 20px;
    }
    @media (max-width: $max-md-screen) {
        gap: 8px;
        font-size: 18px;
    }
    @media (max-width: $max-sm-screen) {
        gap: 4px;
        font-size: 10px;
    }
}

.close-icon {
    font-size: 24px;
    color: rgba(235, 243, 255, 1);
    @media (min-width: $max-xl-screen) {
        font-size: 31.68px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 25.14px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 12.57px;
    }
}

.login-content {
    padding-right: 36px;
    padding-left: 36px;
    gap: 24px;
    @media (min-width: $max-xl-screen) {
        padding-right: 48px;
        padding-left: 48px;
        gap: 48px;
    }
    @media (max-width: $max-md-screen) {
        padding-right: 32px;
        padding-left: 32px;
        gap: 48px;
    }
    @media (max-width: $max-sm-screen) {
        padding-right: 16px;
        padding-left: 16px;
        gap: 24px;
    }
}

.login-form {
    gap: 24px;
    @media (min-width: $max-xl-screen) {
        gap: 31.68px;
    }
    @media (max-width: $max-md-screen) {
        gap: 16px;
    }
    @media (max-width: $max-sm-screen) {
        gap: 12px;
    }
}

.form-check-label {
    font-family: Raleway;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    color: rgba(24, 24, 24, 1);
    @media (min-width: $max-xl-screen) {
        font-size: 17px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 16px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 10px;
    }
}

.login-button {
    border-radius: 2px;
    padding: 12px;
    background: linear-gradient(254.56deg, #3E69A6 0.74%, #233F68 99.26%);
    box-shadow: 4px 4px 2px 0 rgba(0, 47, 164, 0.25), -1px -1px 1px 0px rgba(210, 213, 255, 1);
    @media (min-width: $max-xl-screen) {
        border-radius: 4px;
        padding: 16px;
        box-shadow: 5.28px 5.28px 2.64px 0px rgba(0, 47, 164, 0.25), -1.32px -1.32px 1.32px 0px rgba(210, 213, 255, 1);
    }
    @media (max-width: $max-md-screen) {
        border-radius: 4px;
        padding: 16px;
        box-shadow: 2.19px 2.19px 1.1px 0px rgba(0, 47, 164, 0.25), -0.55px -0.55px 0.55px 0px rgba(210, 213, 255, 1);
    }
    @media (max-width: $max-sm-screen) {
        border-radius: 2px;
        padding: 8px;
        box-shadow: 1.1px 1.1px 0.55px 0px rgba(0, 47, 164, 0.25), -0.27px -0.27px 0.27px 0px rgba(210, 213, 255, 1);
    }
}

.button-text {
    font-family: Raleway;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: center;
    color: rgba(235, 243, 255, 1);
    @media (min-width: $max-xl-screen) {
        font-size: 24px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 20px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 11px;
    }
}

.arrow-icon {
    font-size: 24px;
    color: rgba(235, 243, 255, 1);
    @media (min-width: $max-xl-screen) {
        font-size: 31.68px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 24.28px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 12.14px;
    }
}

.remember-form-check-input-outer {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    border: 1px solid rgba(62, 105, 166, 1);
    background-color: transparent;
    width: 18px;
    height: 18px;
    box-shadow: 2px 2px 5px 0 rgba(0, 56, 159, 0.25), -2px -2px 2px 0 rgba(255, 255, 255, 1);
    @media (min-width: $max-xl-screen) {
        width: 26.4px;
        height: 26.4px;
        border-radius: 2.64px;
        border-width: 1.32px;
        box-shadow: 2.64px 2.64px 6.6px 0px rgba(0, 56, 159, 0.25), -2.64px -2.64px 2.64px 0px rgba(255, 255, 255, 1);
    }

    @media (max-width: $max-md-screen) {
        width: 20px;
        height: 20px;
        border-radius: 2px;
        border-width: 1px;
        box-shadow: 2px 2px 5px 0px rgba(0, 56, 159, 0.25), -2px -2px 2px 0px rgba(255, 255, 255, 1);
    }
    @media (max-width: $max-sm-screen) {
        width: 17.5px;
        height: 17.5px;
        border-radius: 1.75px;
        border-width: 0.88px;
        box-shadow: 1.75px 1.75px 4.38px 0px rgba(0, 56, 159, 0.25), -1.75px -1.75px 1.75px 0px rgba(255, 255, 255, 1);
    }
}

.remember-form-check-input {
    border-radius: 2px;
    background-color: rgba(248, 250, 255, 1);
    margin-top: 0;
    width: 16px;
    height: 16px;
    appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    position: relative;

    @media (min-width: $max-xl-screen) {
        width: 22px;
        height: 22px;
    }
    @media (max-width: $max-md-screen) {
        width: 18px;
        height: 18px;
    }
    @media (max-width: $max-sm-screen) {
        width: 15.5px;
        height: 15.5px;
    }
}

.remember-form-check-input:checked {
    background-color: rgba(62, 105, 166, 1);
    @media (max-width: $max-md-screen) {
        left: 0.25px;
        top: 0.25px;
    }
}

.remember-form-check-input:checked::after {
    content: '';
    position: absolute;
    top: 3px;
    left: 6px;
    width: 4px;
    height: 8px;
    border: solid rgba(248, 250, 255, 1);
    border-width: 0 1.5px 2px 0;
    transform: rotate(45deg);

    @media (min-width: $max-xl-screen) {
        top: 4px;
        left: 8px;
        width: 5px;
        height: 10px;
    }
    @media (max-width: $max-md-screen) {
        top: 3.5px;
        left: 7px;
        width: 4px;
        height: 8px;
        border-width: 0 1px 1.5px 0;
    }
    @media (max-width: $max-sm-screen) {
        top: 3px;
        left: 6px;
        width: 3px;
        height: 7px;
        border-width: 0 1px 1.5px 0;
    }
}

.form-check {
    display: flex;
    align-items: center;
    gap: 15px;
    padding: 0;
    @media (min-width: $max-xl-screen) {
        gap: 19.8px;
    }
    @media (max-width: $max-md-screen) {
        gap: 12px;
    }
    @media (max-width: $max-sm-screen) {
        gap: 10px;
    }
}

.form-item-panel {
    gap: 10px;
    @media (min-width: $max-xl-screen) {
        gap: 16px;
    }
    @media (max-width: $max-md-screen) {
        gap: 12px;
    }
    @media (max-width: $max-sm-screen) {
        gap: 6.08px;
    }
}

.login-form-label {
    font-family: Raleway;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    color: rgba(24, 24, 24, 1);
    margin-bottom: 0px;

    @media (min-width: $max-xl-screen) {
        font-size: 18px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 16px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 10px;
    }
}

.form-control:focus,
.form-control {
    width: 100%;
    height: 62px;
    min-height: 62px;
    border-radius: 2px;
    padding: 16px;
    background: rgba(248, 250, 255, 1);
    border: 1px solid rgba(62, 105, 166, 1);
    font-size: 14px;
    box-shadow: 2px 2px 5px 0 rgba(0, 56, 159, 0.25), -2px -2px 2px 0px rgba(255, 255, 255, 1);

    @media (min-width: $max-xl-screen) {
        height: 81.84px;
        min-height: 81.84px;
        border-radius: 4px;
        padding: 24px;
        border-width: 1.32px;
        font-size: 18px;
    }
    @media (max-width: $max-md-screen) {
        height: 75.42px;
        min-height: 75.42px;
        border-radius: 2.43px;
        border-width: 1.22px;
        padding: 19.46px;
        font-size: 16px;
    }

    @media (max-width: $max-sm-screen) {
        height: 37.71px;
        min-height: 37.71px;
        border-radius: 1.22px;
        border-width: 0.61px;
        padding: 9.73px;
        font-size: 10px;
    }
}

.form-control::placeholder {
    color: rgba(190, 190, 190, 1);
}

.overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6); /* 60% dark overlay */
    z-index: 1; /* must be below the menu but above page content */
}


.menu {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
}

.buttons {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.cancel {
    text-transform: uppercase;
    text-decoration: none;
    color: rgba(38, 38, 38, 1);
}

.btn-link {
    font-family: Raleway;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    color: rgba(24, 24, 24, 1);
    margin-bottom: 0px;

    @media (min-width: $max-xl-screen) {
        font-size: 18px;
    }
    @media (max-width: $max-md-screen) {
        font-size: 16px;
    }
    @media (max-width: $max-sm-screen) {
        font-size: 10px;
    }
}
</style>
